import Configurations from "./configurations";
export default Configurations;
